import { render, staticRenderFns } from "./package.vue?vue&type=template&id=6e67bd44&scoped=true&"
import script from "./package.vue?vue&type=script&lang=js&"
export * from "./package.vue?vue&type=script&lang=js&"
import style0 from "./package.vue?vue&type=style&index=0&id=6e67bd44&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e67bd44",
  null
  
)

export default component.exports